import React, { PureComponent, Fragment, memo } from "react";
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ImagenesRutas } from "../../../request/RutasConfig";

class detalleArticulos extends PureComponent {

    render() {
        const { articulos } = this.props
        return (
            <Fragment>
                {
                    articulos.map(articulo => {
                        return (
                            <div key={articulo.Articulo_Id} className="item-lista">
                                <div className="row no-gutters">
                                    <div className="col-3">
                                        <img src={articulo.Imagen_Path == 'https://dummyimage.com/100x100' ? ImagenesRutas.ArtDefault : articulo.Imagen_Path} />
                                    </div>
                                    <div className="col-9">
                                        <p className="item-name">
                                            {`${articulo.Articulo_Codigo_Principal ? articulo.Articulo_Codigo_Principal : articulo.Articulo_Id} - ${articulo.Articulo_Nombre}`}
                                        </p>
                                        <p className="quantity-item">Cantidad: {articulo.Detalle_Facturar}</p>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </Fragment>
        )
    }
}

const mapStateToProps = state => {
    return {
        token: state.usuario.token,
        usuarioLogueado: state.usuario.usuarioLogueado,
        empresa: state.parametros.empresa,
        callCenter: state.parametros.callCenter
    };
};

export default connect(mapStateToProps)(withRouter(memo(detalleArticulos)));